module.exports = __webpack_public_path__ + "static/media/smiling-face-outline.20f510d4.svg";